export enum IndicadorEnum {
    OK= 'OK',
    ERROR= 'ERROR',
    INVALID_FORMATO_RUT= 'INVALID_FORMATO_RUT',
    INVALID_ENTRADA_CI= 'INVALID_ENTRADA_CI',
    INVALID_ENTRADA_CAPTCHA= 'INVALID_ENTRADA_CAPTCHA',
    SS_EN_CURSO= 'SS_EN_CURSO',
    INTENTOS_AGOTADOS= 'INTENTOS_AGOTADOS',
    CEDULA_BLOQUEADA= 'CEDULA_BLOQUEADA',
    FORMATO_INCORRECTO= 'FORMATO_INCORRECTO',
    SAVE_DATOS_PERSONALES_OK= 'SAVE_DATOS_PERSONALES_OK',
    GET_DATOS_PERSONALES_OK= 'GET_DATOS_PERSONALES_OK',
    FORMATO_RUT_VALIDO= 'FORMATO_RUT_VALIDO',
    FORMATO_RUT_INVALIDO= 'FORMATO_RUT_INVALIDO',
    NACIONALIDADES_OK= 'NACIONALIDADES_OK',
    TOKEN_EXPIRADO= 'TOKEN_EXPIRADO',
    DATOS_EDITABLES= 'DATOS_EDITABLES',
    DATOS_NO_EDITABLES= 'DATOS_NO_EDITABLES',
    GUARDADO_CONFIGURACION_PRODUCTO= 'GUARDADO_CONFIGURACION_PRODUCTO',
    ERROR_GUARDADO_CONFIGURACION_PRODUCTO= 'ERROR_GUARDADO_CONFIGURACION_PRODUCTO',
    ERROR_DATOS_INCORRECTOS= 'ERROR_DATOS_INCORRECTOS',
    GUARDADO_REGISTRO_SOCIO= 'GUARDADO_REGISTRO_SOCIO',
    ELIMINAR_SOCIO= 'ELIMINAR_SOCIO',
    DOCUMENTO_CORRUPTO= 'DOCUMENTO_CORRUPTO',
    DOCUMENTO_ENCRIPTADO= 'DOCUMENTO_ENCRIPTADO',
    FORMATO_DOCUMENTO_INVALIDO= 'FORMATO_DOCUMENTO_INVALIDO',
    TAMANO_DOCUMENTO_EXCEDIDO= 'TAMANO_DOCUMENTO_EXCEDIDO',
    DOCUMENTO_REQ_NO_ADJUNTO= 'DOCUMENTO_REQ_NO_ADJUNTO',
    RUN_NO_ENCONTRADO= 'RUN_NO_ENCONTRADO',
    RUN_INVALIDO= 'RUN_INVALIDO',
    COMERCIO_INFORMAL= 'COMERCIO_INFORMAL',
    CORREO_NO_COINCIDE= 'CORREO_NO_COINCIDE',
    PROCESO_SEGUNDO_PLANO= 'PROCESO_SEGUNDO_PLANO',
    COMERCIO_NO_AGENDABLE= 'COMERCIO_NO_AGENDABLE',
    ERROR_INTEGRACION_TERCERO= 'ERROR_INTEGRACION_TERCERO',
    OBTIENE_DECLARACION_JURADA_OK= 'OBTIENE_DECLARACION_JURADA_OK',
    REGISTRA_DECLARACION_JURADA_OK= 'REGISTRA_DECLARACION_JURADA_OK',
    OBTIENE_URL_PAGO_OK= 'OBTIENE_URL_PAGO_OK',
    FECHA_NO_DISPONIBLE= 'FECHA_NO_DISPONIBLE',
    ESTADO_INAPROPIADO= 'ESTADO_INAPROPIADO',
    APROBADOR_NO_AUTORIZADO= 'APROBADOR_NO_AUTORIZADO',
    CEDULA_VENCIDA= 'CEDULA_VENCIDA',
    DOCUMENTO_YA_APROBADO= 'DOCUMENTO_YA_APROBADO',
    FECHA_AGENDAMIENTO_VENCIDA= 'FECHA_AGENDAMIENTO_VENCIDA',
    NO_AUTORIZADO= 'NO_AUTORIZADO',
    CATEGORIA_NO_ACEPTADA= 'CATEGORIA_NO_ACEPTADA',
    OBTIENE_DIRECCION_INSTALACION_OK= 'OBTIENE_DIRECCION_INSTALACION_OK',
    GESTIONA_COMERCIO_OK= 'GESTIONA_COMERCIO_OK',
    PERSONA_DIFUNTA= 'PERSONA_DIFUNTA',
    DOCUMENTO_EXISTE= 'DOCUMENTO_EXISTE'
}
